import { Row, Col, Container, Card, Button, Table, Badge, Modal, Form, Spinner } from "react-bootstrap";
import Layout from "../../../components/Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Paginator from "../../../components/table/Paginator";
import { useEffect, useRef, useState } from "react";
import DrewsModal from "../../../components/modal/DrewsModal";
import { useDispatch, useSelector } from "react-redux";
import { applyPayCode, getVouchers, managerCheckPaycodeBalance } from "../../../redux/slices/managers.slice";
import Swal from "sweetalert2";
import formatCurrency from "../../../utils/currencyFormmter";
import CryptoJS from "crypto-js";
import { verifyWalletPin } from "../../../redux/slices/users";
import dateFormatter from "../../../utils/dateFormatter";
import AmountInput from "../../../components/AmountInput";
import RecordFilter from "../../../components/RecordFilter";

const PaycodeVouchers = () => {

    const dispatch = useDispatch();
    const isLoaded = useRef(false)

    const initialState = {
        show: false,
        showBalance: false,
        payload: { page: 1 },
        loading: false,
        paycodes: [],
        errors: {},
        decrypted: null,
        paycode: {},
        claim_code: false,
        errorMessage: null,
        analytics: {},
        paginationData: {},
        paycodeForm: false,
    }

    const [state, setState] = useState(initialState)

    const secretPass = 'ZphGxxfW2t2q'

    useEffect(() => {
        if(!isLoaded.current) {
            loadPaycodes()
            isLoaded.current = true
        }
    }, [state.payload.page])

    const handleEncryption = (txt) => {
        return CryptoJS.AES.encrypt(JSON.stringify(txt), secretPass).toString()
    }

    const selectPaycode = (item) => {
       let encrypted = handleEncryption(item?.secret)
        setState((prevState) => ({...prevState, show: true, paycode: item, decrypted: encrypted}))
    }

    const handleInput = (event) => {
        const { name, value } = event.target
        setState((prevState)=> ({...prevState, payload:{...prevState.payload, [name]: value}}))
    }

    const handleValidation = (event) => {

        const regex = /^\d*\.?\d*$/;
        const pattern = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,9}[\.][a-z]{2,5}/g;
    
        const {name, value} = event.target
        if(value === '' && event.target.attributes.required) {
            event.target.style = "border: 1px solid red"
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors, [name]: `${name[0].toUpperCase() + name.split('_').join(' ').slice(1)} is required`}}))
        }

        else if (name ==='amount' && !regex.test(parseFloat(value.replace(/[^\d.]/g, '')))) {
            event.target.style = "border: 1px solid red"
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors, [name]: `${name[0].toUpperCase() + name.split('_').join(' ').slice(1)} is required`}}))
        }
        else {
            event.target.style = "border-style: transparent"
            delete state.errors[name]
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors}}))
        }
    }

    const usePaycode = () => {
        if(!state.payload.amount && !state.payload.pin && !state.payload.secret)  { return }

        setState((prevState) => ({...prevState, loading: true}))
        dispatch(applyPayCode(state.payload))
        .then((response) => {
            if(response.payload?.success === true) {
                Swal.fire({
                    icon: 'success',
                    text: response.payload?.message
                })
                .then(() => setState((prevState) => ({...prevState, claim_code: false})))
            }
            else {
                Swal.fire({
                    icon: 'error',
                    text: response.payload?.message
                })
            }
        })
        .finally(() => setState((prevState) => ({...prevState, loading: false})))
    }

    const loadPaycodes = () => {
        setState((prevState) => ({...prevState, loading: true}))
        dispatch(getVouchers(state.payload))
        .then((response) => {
            let results = []
            let analytics = {}
            if(response.payload?.results) {
                results = response.payload?.results
            }
            if(response.payload?.analytics) {
                analytics = response.payload?.analytics
            }
            setState((prevState) => ({...prevState, results: results, analytics: analytics}))
        })
        .finally(() => setState((prevState) => ({...prevState, loading: false})))
    }

    const verifyPin = () => {
        setState((prevState) => ({...prevState, loading: true}))
        dispatch(verifyWalletPin(state.payload))
        .then((response) => {
            if(response.payload?.success === true) {
                setState((prevState) => ({...prevState, decrypted: state.paycode?.secret}))
            }
            else {
                Swal.fire({
                    icon: 'error',
                    text: response.payload?.message
                })
            }
        })
        .finally(() => setState((prevState) => ({...prevState, loading: false})))
    }

    const paycodeBalance = () => {
        if(!state.payload.paycode && !state.payload.secret_word)  {  return }
        
        setState((prevState) => ({...prevState, loading: true}))
        dispatch(managerCheckPaycodeBalance(state.payload))
        .then((response) => {
            if(response.payload?.success === true) {
                Swal.fire({
                    icon: 'info',
                    text: response.payload?.message
                })
                .then(() => setState((prevState) => ({...prevState, showBalance: false})))
            }
            else {
                Swal.fire({
                    title: 'Error',
                    icon: 'error',
                    text: response?.payload?.message || 'An error occured'
                })
            }
        })
        .finally(() => setState((prevState) => ({...prevState, loading: false})))
    }
    
    const handleAmountUpdate = (data) => {
        const cleanAmount = data.split(',').join('')
        setState((prevState) => ({...prevState, payload: {...prevState.payload, amount: cleanAmount}}))
    }

    const handlePagination = (data) => {
        isLoaded.current = false
        setState((prevState) => ({...prevState, payload: {...prevState.payload, page: data}}))
    }

    return (
        <Layout>
            <Container className="mt-4 px-4 mb-4">
                <Row className="mb-2">
                    <Col md={6}>
                        <h3 className="mb-0">Paycode Payment</h3>
                        <p className="text-primary font-bold">You have claimed ₦0 paycodes.</p>
                    </Col>
                    <Col md={6}>
                        <div className="text-right">
                            <Button 
                                type="button" 
                                variant="light" 
                                className="text-white bg-primary border-0 mb-2 mx-2"
                                onClick={ () => setState((prevState) => ({...prevState, showBalance: true}))}
                            >
                                <span className="ps-2">Check Balance</span>
                            </Button>
                            <Button 
                                type="button" 
                                variant="light" 
                                className="text-white bg-primary border-0 mb-2"
                                onClick={() => setState((prevState) => ({...prevState, claim_code: true}))}
                            >
                                <FontAwesomeIcon icon='plus' />
                                <span className="ps-2">Claim Paycode</span>
                            </Button>
                        </div>
                    </Col>
                </Row>

                <div>
                    <RecordFilter
                        handleInput={handleInput}
                        handleSearchSubmit={loadPaycodes}
                        params={[
                            {label: 'Date', value: 'date'},
                        ]}
                    />
                    <Card className="shadow-sm">
                        <Card.Body className="table-responsive-lg table-striped">
                            <Table size="sm" className="table-color">
                                <thead>
                                    <tr>
                                        <th>Transaction ID</th>
                                        <th>Customer Name</th>
                                        <th>Paycode</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                        <th>Date Created</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        state.loading && 
                                        <tr>
                                            <td colSpan={7} className="in-page-loader">
                                                <Spinner size="sm" variant="primary"/>
                                            </td>
                                        </tr>
                                    }
                                    {
                                        state.paycodes?.length ? (
                                            state.paycodes.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        {item.reference}
                                                    </td>
                                                    <td>
                                                        <strong>
                                                            {item.owner}
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {item.token}
                                                    </td>
                                                    <td>
                                                        {formatCurrency(item.amount).with_currency}
                                                    </td>
                                                    <td>
                                                        <p className="d-flex m-0 align-items-center justify-content-between">
                                                            <Badge 
                                                                className={item.valid_detail ? 'badge-active' : 
                                                                (item.used === 'used' ? 'badge-used' : 
                                                                (!item.valid_detail ? 'badge-failed' : 'badge-pending')
                                                                )}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                                    <circle cx="5" cy="5" r="5" fill={
                                                                        item.valid_detail ? "#008000" : 
                                                                        (item.used ? "#828282" : "#FAB941")
                                                                    }
                                                                    />
                                                                </svg>
                                                                <span className="ps-1">
                                                                    {item.valid_detail ? 'Active' : (item.used ? 'Used' : 'Expired')}
                                                                </span>
                                                            </Badge> 
                                                            {/* <Dropdown>
                                                                <Dropdown.Toggle variant="light" className="border-0 bg-white" size="sm" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon="ellipsis-vertical" style={{fontSize: "20px"}} className="text-muted"/>
                                                                </Dropdown.Toggle>
    
                                                                <Dropdown.Menu className="border-0 shadow px-3 py-4">
                                                                    <Dropdown.Item 
                                                                        eventKey={1} 
                                                                        className="text-primary d-flex align-items-center gap-1" 
                                                                        onClick={() => paycodeSelection(item.id)}
                                                                    >
                                                                    <i className="lni lni-eye" style={{fontSize: "20px"}}></i>  View Ticket
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Divider />
                                                                    <Dropdown.Item 
                                                                        eventKey={2} 
                                                                        className="d-flex align-items-center gap-1"
                                                                        onClick={ () => paycodeSelection(item.id) }
                                                                    >
                                                                        <FontAwesomeIcon icon="folder-open" /> Re-open Ticket
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown> */}
                                                        </p>
                                                    </td>
                                                    <td>
                                                        {dateFormatter(item.date)}
                                                    </td>
                                                </tr>
                                            ))
                                        )
                                        :
                                        (
                                            <tr>
                                                <td colSpan={5} className="text-center text-muted">No data found</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                    {
                        state.paycodes?.length ? (
                            <div className="table-responsive mt-2">
                                <Paginator
                                    next={state.paginationData.next} 
                                    prev={state.paginationData.prev}
                                    setCurrentPage={ handlePagination }
                                />
                            </div>
                        ) : null
                    }
                </div>

                <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={state.claim_code}
                    onHide={() => setState((prevState) => ({...prevState, claim_code: false}))}
                    backdrop="static"
                >
                    <Modal.Header closeButton>Claim Voucher</Modal.Header>
                    <Modal.Body className="px-4">
                        <Form>
                            <Row>
                                <Form.Group as={Col} md="12" className="mb-3">
                                    <Form.Label className="mb-0">PayCode</Form.Label>
                                    <Form.Control
                                        type="text"
                                        required
                                        placeholder="PayCode"
                                        name="pin"
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                        minLength={6}
                                        maxLength={6}
                                    />
                                    {
                                        state.errors['pin'] && 
                                        <Form.Text className="text-danger">{state.errors['pin']}</Form.Text>
                                    }
                                </Form.Group>

                                <Form.Group as={Col} md="12" className="mb-3">
                                    <Form.Label className="mb-0">Secret Word</Form.Label>
                                    <Form.Control
                                        type="password"
                                        required
                                        placeholder="Secret Word"
                                        name="secret"
                                        maxLength={6}
                                        minLength={6}
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                    />
                                    {
                                        state.errors['secret'] && 
                                        <Form.Text className="text-danger">{state.errors['secret']}</Form.Text>
                                    }
                                </Form.Group>

                                <Form.Group as={Col} md="12" className="mb-3">
                                    <Form.Label className="mb-0">Amount</Form.Label>
                                    <AmountInput onChange={handleAmountUpdate} />
                                    {
                                        state.errors['amount'] && 
                                        <Form.Text className="text-danger">{state.errors['amount']}</Form.Text>
                                    }
                                </Form.Group>
                                <Form.Group 
                                    as={Col} 
                                    md="12" 
                                    controlId="validationCustom011" 
                                    className="mt-4 d-grid"
                                >
                                    <Button 
                                        variant="primary" 
                                        size="lg" 
                                        onClick={usePaycode}
                                        disabled={Object.keys(state.errors).length > 0}
                                    >
                                        Claim PayCode <Spinner animation={ state.loading ? "border" : null} role="status" size="sm"></Spinner>
                                    </Button>
                                </Form.Group>
                            </Row>
                        </Form>
                    </Modal.Body>
                </Modal>

                <DrewsModal
                    show={state.showBalance}
                    onHide={() => setState((prevState) => ({...prevState, showBalance: false}))}
                    size="md"
                    dismissable={true}
                    title="Voucher Balance"
                >
                    <Form>
                        <Row>
                            <Form.Group as={Col} md="12" className="mb-3">
                                <Form.Label className="mb-0">Voucher's Code</Form.Label>
                                <Form.Control
                                    type="text"
                                    required
                                    placeholder="PayCode"
                                    name="paycode"
                                    onChange={handleInput}
                                    onKeyUp={handleValidation}
                                    minLength={6}
                                    maxLength={6}
                                />
                                {
                                    state.errors['paycode'] && 
                                    <Form.Text className="text-danger">{state.errors['paycode']}</Form.Text>
                                }
                            </Form.Group>

                            <Form.Group as={Col} md="12" className="mb-3">
                                <Form.Label className="mb-0">Secret Word</Form.Label>
                                <Form.Control
                                    type="password"
                                    required
                                    placeholder="Secret Word"
                                    name="secret_word"
                                    onChange={handleInput}
                                    onKeyUp={handleValidation}
                                />
                                {
                                    state.errors['secret_word'] && 
                                    <Form.Text className="text-danger">{state.errors['secret_word']}</Form.Text>
                                }
                            </Form.Group>
                                <p className="text-danger text-sm">
                                    {state.errorMessage}
                                </p>
                            <Form.Group 
                                as={Col} 
                                md="12" 
                                controlId="validationCustom011" 
                                className="mt-4 d-grid"
                            >
                                <Button 
                                    variant="primary" 
                                    size="lg" 
                                    onClick={paycodeBalance}
                                    disabled={Object.keys(state.errors).length > 0}
                                >
                                    Check Balance <Spinner animation={ state.loading ? "border" : null} role="status" size="sm"></Spinner>
                                </Button>
                            </Form.Group>
                        </Row>
                    </Form>
                </DrewsModal>

            </Container>
        </Layout>
    );
}

export default PaycodeVouchers;